import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConstantService } from "app/Shared/Services/constant-service";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { CAISAuditTrailComponent } from "./cais-audit-trail.component";

@Component({
    selector: 'app-cais-audit-trail-dialog',
    imports: [DialogModule, ButtonModule, CAISAuditTrailComponent],
    template: `<p-dialog 
                header="CAIS Audit Trail History"
                id="cais-audit-trail" 
                height="auto"
                [(visible)]="isOpenClose" 
                [modal]="true" 
                [minY]="70" 
                [maximizable]="true"
                [baseZIndex]="10000" 
                draggable="true" 
                [closable]="true" 
                (onHide)="closeDialogbox()" 
                appendTo="body"
                [style]="{'width': '95%', 'max-width': '95vw', 'min-width': '200px'}"
                styleClass="audit-trail-dialog">
              <div class="ui-grid-col-12  nopadding container">
                <app-cais-audit-trail 
                    [SelectedRow]="selectedRow" [pageName]="pageName">
                </app-cais-audit-trail>
              </div>

          <ng-template #footer>
                <p-button type="button" id="cais-audit-trail-close" (click)="closeDialogbox()" 
                  label="Close" icon="fa fa-close" class="footer-button">
                </p-button>
              </ng-template>
            </p-dialog>`,
    styles: [
        `.container {
        max-width: 100% !important;
        min-height: auto !important;
        z-index: 1006 !important;
        opacity: 1 !important;
    }
    ::ng-deep .audit-trail-dialog .p-dialog-header > .p-dialog-title {
    font-size: 17.5px !important;
    color: #1b1d1f !important;
    }
    ::ng-deep .footer-button .p-button {
    padding: 9px !important;
    cursor: pointer!important;
    background: #e54a23 !important;
    border-color: #e54a23 !important;
    margin:2px;
    }`
    ]
})
export class CAISAuditTrailDialogComponent implements OnInit {
  @Output() closeEventDialog: EventEmitter<boolean> = new EventEmitter();
  @Input('SelectedRow') selectedRow: any = [];
  @Input('pageName') pageName!: string;
  @Input('isAuditTrailOpen') isOpenClose: boolean = false;

  constructor(public constantService: ConstantService) {

  }
  closeDialogbox() {
    this.isOpenClose = false;
    this.closeEventDialog.emit(true);
  }
  ngOnInit() {
  }
}